import get from 'lodash/get'
import { ReduxState } from '../../types/'

const form = 'form.PennyPayment.values'

export const getPennyPaymentForm = (state: ReduxState) => ({
  bankCode: get(state, `${form}.bankCode`, ''),
  number: get(state, `${form}.number`, ''),
  prefix: get(state, `${form}.prefix`, ''),
})
